// ./src/StackedOverlay.tsx — Mantine's Modal and Drawer, ON THE OVERLAY STACK (suggested task "Make create-in-place
// drawers slide in", review round 3, 2026-10-03).
//
// ⚠⚠ A plain Mantine Modal / Drawer opened inside an AppDrawer (a tags picker, an option picker, an icon selector, an image
//   viewer, a full-screen editor…) was not on the stack: one Esc closed it AND the drawer under it (Mantine closes every
//   open one, and the drawer still believed it was on top), and ⌘S inside the picker saved the drawer underneath.
//   These are the same components, registered while open: Esc closes only the top one, and the drawer's shortcuts
//   stand aside while they are open (see overlayStack.ts). Use them instead of `@mantine/core`'s Modal / Drawer —
//   `check-drawer-mount` fails on a raw one.
import React from "react";
import { Drawer, Modal, type DrawerProps, type ModalProps } from "@mantine/core";

import { useOverlayStack } from "./overlayStack";

/** Mantine's `Modal`, on the overlay stack. */
export const StackedModal: React.FC<ModalProps> = (props) => {
  const isTop = useOverlayStack(!!props.opened);

  return <Modal {...props} closeOnEscape={(props.closeOnEscape ?? true) && isTop} />;
};

/** Mantine's `Drawer`, on the overlay stack. */
export const StackedDrawer: React.FC<DrawerProps> = (props) => {
  const isTop = useOverlayStack(!!props.opened);

  return <Drawer {...props} closeOnEscape={(props.closeOnEscape ?? true) && isTop} />;
};
